<template>
  <div id="annonce-create-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="annonce-create-step-right-part-inside" class="w-100">
      <div class="col-12 pl-0 pr-0 mb-1" v-if="isLicensedAndNeedPlate">
        <b-form-group
          :label="$t('annonce.vehicle.Plate')+'*'"
          class="small-text"
          :invalid-feedback="licensePlate.invalidFeedback"
          label-for="licensePlate-input">
          <b-form-input
            :state="licensePlate.state"
            id="licensePlate-input"
            @change="setAnnonce;updateFeedbackLicensePlate()"
            v-model="licensePlate.value"
            :formatter="IdentifierUtils.formatLicensePlate"
            required>
          </b-form-input>
        </b-form-group>

        <b-form-group
          :label="$t('annonce.vehicle.Plate.confirm')+'*'"
          class="small-text"
          :invalid-feedback="licensePlateConfirm.invalidFeedback"
          label-for="licensePlateConfirm-input">
          <b-form-input
            :state="licensePlateConfirm.state"
            id="licensePlateConfirm-input"
            @change="updateFeedbackLicensePlateConfirm()"
            v-model="licensePlateConfirm.value"
            :formatter="IdentifierUtils.formatLicensePlate"
            required>
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1" v-else-if="isNotLicensedAndNeedVIN">
        <b-form-group
          :label="$t('annonce.vehicle.vin')+'*'"
          class="small-text"
          :invalid-feedback="vin.invalidFeedback"
          label-for="vin-input">
          <b-form-input
            :state="vin.state"
            id="vin-input"
            @change="setAnnonce;updateFeedbackVin()"
            v-model="vin.value"
            :formatter="IdentifierUtils.formatVin"
            :required="!serialNumber.value">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1" v-else-if="isNotLicensedAndNeedBicycode">
        <b-form-group
          :label="$t('annonce.vehicle.bicycode')+'*'"
          class="small-text"
          :invalid-feedback="bicycode.invalidFeedback"
          label-for="bicycode-input">
          <b-form-input
            :state="bicycode.state"
            id="bicycode-input"
            @change="setAnnonce;updateFeedbackBicycode()"
            :required="!serialNumber.value"
            v-model="bicycode.value"
            :formatter="IdentifierUtils.formatBicycode">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-2 choice-id-vehicule" v-if="isNotLicensedAndNeedSerialNumberPlusAnother">{{ $t('annonce.vehicle.bicycode.and.or.serialNumber') }}</div>

      <div class="col-12 pl-0 pr-0 mb-1" v-if="isNotLicensedAndNeedSerialNumber">
        <b-form-group
          :label="$t('annonce.vehicle.serialNumber')+'*'"
          class="small-text"
          :invalid-feedback="serialNumber.invalidFeedback"
          label-for="serialNumber-input">
          <b-form-input
            :state="serialNumber.state"
            id="serialNumber-input"
            @change="setAnnonce;removeInvalidFeedback('serialNumber')"
            v-model="serialNumber.value"
            :required="!bicycode.value && !vin.value">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.vehicle.Color')+'*'"
          label-for="color-input"
          class="small-text"
          :invalid-feedback="color.invalidFeedback"
          :state="color.state">
          <b-form-select
            id="color-input"
            v-model="color.value"
            @change="setAnnonce;removeInvalidFeedback('color')"
            :state="color.state"
            required>
            <option v-for="color in colors" :value="color.value">
              {{ $t(color.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.vehicle.Energy')+'*'"
          label-for="energy-input"
          class="small-text"
          :invalid-feedback="energy.invalidFeedback"
          :state="energy.state">
          <b-form-select
            id="energy-input"
            v-model="energy.value"
            @change="setAnnonce;removeInvalidFeedback('energy')"
            :state="energy.state"
            required>
            <option v-for="energy in energies" :value="energy.value">
              {{ $t(energy.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.place.robbery')+'*'"
          label-for="address-input"
          class="small-text"
          :invalid-feedback="address.invalidFeedback"
          :state="address.state">
          <b-input-group>
            <GmapAutocomplete
              ref="addressAutocomplete"
              id="address-input"
              class="form-control"
              required
              @change="removeInvalidFeedback('address')"
              @input="handleStartAddressInput"
              @place_changed="handleAddressSelect"
              v-model="address.value"
              :options="autocompleteOptions">
            </GmapAutocomplete>
            <b-input-group-append>
              <div id="pin-locate" :class="locationPermission === 'granted' ? 'custom-append-locate cursor-pointer' : 'custom-append-locate-disabled'" @click="locateUser">
                <i class="ph-custom ph-map-pin" :class="locationPermission === 'granted'  ? 'main-color' : 'text-disabled'"/>
              </div>
            </b-input-group-append>
            <b-tooltip v-if="locationPermission !== 'granted'" target="pin-locate" placement="bottom" triggers="hover">
              {{ $t('autorisation.geolocation.tooltip') }}
            </b-tooltip>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group  v-slot="{ ariaDescribedby }" :invalid-feedback="isProprio.invalidFeedback" :state="isProprio.state">
          <b-form-radio v-model="isProprio.value"  :value="true" class="mb-2 mt-2 radio-proprio" @change="setAnnonce;removeInvalidFeedback('isProprio')"><span class="ml-2">{{$t('annonce.is.prorio')}}</span></b-form-radio>
          <p class="small-text main-grey-medium-color mb-3">{{$t('annonce.leasing')}}</p>
          <b-form-radio v-model="isProprio.value"  :value="false" class="radio-proprio"><span class="ml-2" @change="setAnnonce;removeInvalidFeedback('isProprio')">{{$t('annonce.not.prorio')}}</span></b-form-radio>
        </b-form-group>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6 pl-0 mb-1" v-if="isProprio.value === false">
            <b-form-group
              :label="$t('annonce.lastnameOwner')"
              label-for="lastnameOwner-input"
              :invalid-feedback="lastnameOwner.invalidFeedback"
              class="small-text">
              <b-form-input
                id="lastnameOwner-input"
                v-model="lastnameOwner.value"
                @input="setAnnonce;removeInvalidFeedback('lastnameOwner')"
                :state="lastnameOwner.state"
                required>
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-6 pr-0 mb-1" v-if="isProprio.value === false">
            <b-form-group
              :label="$t('annonce.firstnameOwner')"
              label-for="firstnameOwner-input"
              :invalid-feedback="firstnameOwner.invalidFeedback"
              class="small-text">
              <b-form-input
                id="firstnameOwner-input"
                v-model="firstnameOwner.value"
                @input="setAnnonce;removeInvalidFeedback('firstnameOwner')"
                :state="firstnameOwner.state"
                required>
              </b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="col-12 pl-0 pr-0 mb-1" v-if="isProprio.value === false">
        <b-form-group
          :label="$t('identityRectoFile')"
          label-for="recto-input"
          :invalid-feedback="identityRecto.invalidFeedback"
          :state="identityRecto.state"
          class="small-text">
          <b-form-file
            id="recto-input"
            :browse-text="$t('Select')"
            v-model="identityRecto.value"
            @input="setAnnonce($event);removeInvalidFeedback('identityRecto')"
            :placeholder="identityRecto.fileName"
            required
            accept=".png, .jpeg, .jpg, .pdf">
          </b-form-file>
        </b-form-group>
      </div>
      <div class="col-12 pl-0 pr-0 mb-1" v-if="isProprio.value === false">
        <b-form-group
          :label="$t('identityVersoFile')"
          label-for="verso-input"
          :invalid-feedback="identityVerso.invalidFeedback"
          :state="identityVerso.state"
          class="small-text">
          <b-form-file
            id="verso-input"
            :browse-text="$t('Select')"
            v-model="identityVerso.value"
            @input="setAnnonce($event);removeInvalidFeedback('identityVerso')"
            :placeholder="identityVerso.fileName"
            required
            accept=".png, .jpeg, .jpg, .pdf">
          </b-form-file>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import IdentifierUtils from "../../../utils/IdentifierUtils";
import AddressUtils from "../../../utils/AddressUtils";

export default {
  name: "AnnonceCreateStep4",

  emits:["updateAnnonce"],

  props:{
    annonce : {
      required: true,
      type: Object
    },
    isLicensed : {
      required: true,
    },
    hasBicycode : {
      required: true,
    },
    hasSerialNumber : {
      required: true,
    },
    hasVIN : {
      required: true,
    },
  },

  data(){
    return {
      IdentifierUtils: IdentifierUtils,

      locationPermission: null,
      energies : [],
      colors : [],
      licensePlate:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      licensePlateConfirm:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      vin:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      bicycode:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      serialNumber:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      energy:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      color:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      address:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      isProprio:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      identityRecto:{
        state: null,
        invalidFeedback: null,
        fileName:"",
        value: null
      },
      identityVerso:{
        state: null,
        invalidFeedback: null,
        fileName:"",
        value: null
      },
      firstnameOwner:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      lastnameOwner:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      autocompleteOptions: {
        componentRestrictions: {
          country: [
            'fr',
            this.$store.state.currentUserCountryCode
          ],
        },
      },
    }
  },


  watch: {
    'isProprio.value': function (newVal) {
      this.isProprio.value = newVal

      if(newVal===true){
        this.identityRecto.value = null
        this.identityRecto.fileName = ""
        this.identityRecto.state = null
        this.identityRecto.invalidFeedback = null

        this.identityVerso.value = null
        this.identityVerso.fileName = ""
        this.identityVerso.state = null
        this.identityVerso.invalidFeedback = null

        this.firstnameOwner.value = null
        this.firstnameOwner.state = null
        this.firstnameOwner.invalidFeedback = null

        this.lastnameOwner.value = null
        this.lastnameOwner.state = null
        this.lastnameOwner.invalidFeedback = null
      }

      this.setAnnonce()
    },
  },


  async mounted() {
    this.setInitialValues()
    await this.fetchEnergies()
    await this.fetchColors()

    if ("permissions" in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then(permission => {
        this.locationPermission = permission.state;
      });
    }
  },

  computed:{
    isLicensedAndNeedPlate(){
      return this.isLicensed === true
    },

    isNotLicensedAndNeedVIN(){
      return this.isLicensed === false && this.hasVIN === true
    },

    isNotLicensedAndNeedBicycode(){
      return this.isLicensed === false && this.hasVIN === false && this.hasBicycode === true
    },

    isNotLicensedAndNeedSerialNumber(){
      return this.isLicensed === false && this.hasSerialNumber === true
    },

    isNotLicensedAndNeedSerialNumberPlusAnother(){
      return this.isLicensed === false && (this.hasVIN === true || this.hasBicycode === true) && this.hasSerialNumber === true
    },


  },

  methods:{

    setAnnonce(){
      this.annonce.licensePlate=this.licensePlate
      this.annonce.licensePlateConfirm=this.licensePlateConfirm
      this.annonce.vin=this.vin
      this.annonce.bicycode=this.bicycode
      this.annonce.serialNumber=this.serialNumber
      this.annonce.energy=this.energy
      this.annonce.color=this.color
      this.annonce.address=this.address
      this.annonce.isProprio=this.isProprio
      this.annonce.identityRecto=this.identityRecto
      this.annonce.identityVerso=this.identityVerso
      this.annonce.firstnameOwner=this.firstnameOwner
      this.annonce.lastnameOwner=this.lastnameOwner

      this.$emit('updateAnnonce', this.annonce)
    },

    async fetchEnergies(){
      api
        .get(`/apiMobile/getEnergies`)
        .then(response => {
          this.energies = response.data
        })
    },

    async fetchColors(){
      api
        .get(`/apiMobile/getColors`)
        .then(response => {
          this.colors = response.data
        })
    },

    setInitialValues(){
      this.licensePlate=this.annonce.licensePlate
      this.licensePlateConfirm=this.annonce.licensePlateConfirm
      this.vin=this.annonce.vin
      this.bicycode=this.annonce.bicycode
      this.serialNumber=this.annonce.serialNumber
      this.energy=this.annonce.energy
      this.color=this.annonce.color
      this.address=this.annonce.address
      this.isProprio = this.annonce.isProprio
      this.firstnameOwner = this.annonce.firstnameOwner
      this.lastnameOwner = this.annonce.lastnameOwner
      this.identityRecto = this.annonce.identityRecto
      if(this.annonce.identityRecto.value){
        this.identityRecto.fileName = this.annonce.identityRecto.value.name
      }
      this.identityVerso = this.annonce.identityVerso
      if(this.annonce.identityVerso.value){
        this.identityVerso.fileName = this.annonce.identityVerso.value.name
      }
    },

    handleStartAddressInput(value) {
      if (value instanceof InputEvent) {
        this.address.value = value.target.value;
      } else {
        this.address.value = value;
      }
      this.address.state=null
      this.address.invalidFeedback=null
      this.setAnnonce()

    },

    handleAddressSelect(place) {
      if (place && place.formatted_address) {
        this.address.value = place.formatted_address
      }
    },

    locateUser() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            AddressUtils.convertLatLongToAddress(lat, lng, (address) => {
              this.address.value = address;
              this.address.state = true;
              this.address.invalidFeedback = null;
            });
          },
          () => {
          }
        );
      }
    },

    updateFeedbackLicensePlate() {
      var newVal = this.licensePlate.value
      if(newVal === null || newVal === "" || newVal.trim() === "") {
        this.licensePlate.value = null
        this.licensePlate.state = null
        this.licensePlate.invalidFeedback = null
        return
      }
      const validPlate = IdentifierUtils.validateLicensePlate(newVal)
      if (validPlate) {
        this.licensePlate.value = validPlate
        this.licensePlate.state = true
        this.licensePlate.invalidFeedback = null
      } else {
        this.licensePlate.state = false
        this.licensePlate.invalidFeedback = this.$i18n.t('annonce.licensePlate.invalidFeedBack')
      }
    },

    updateFeedbackLicensePlateConfirm() {
      var newVal = this.licensePlateConfirm.value
      if(newVal === null || newVal === "" || newVal.trim() === "") {
        this.licensePlateConfirm.value = null
        this.licensePlateConfirm.state = null
        this.licensePlateConfirm.invalidFeedback = null
        this.updateFeedbackLicensePlate()
        return
      }
      const validPlate = IdentifierUtils.validateLicensePlate(newVal)
      if (this.licensePlate.value === validPlate) {
        this.licensePlateConfirm.value = validPlate
        this.licensePlateConfirm.state = true
        this.licensePlateConfirm.invalidFeedback = null
        this.updateFeedbackLicensePlate()
      } else {
        this.licensePlate.state = false
        this.licensePlate.invalidFeedback = this.$i18n.t('annonce.licensePlateConfirm.invalidFeedBack')
        this.licensePlateConfirm.state = false
        this.licensePlateConfirm.invalidFeedback = this.$i18n.t('annonce.licensePlateConfirm.invalidFeedBack')
      }
    },

    updateFeedbackVin() {
      var newVal = this.vin.value
      if(newVal === null || newVal === "" || newVal.trim() === "") {
        this.vin.value = null
        this.vin.state = null
        this.vin.invalidFeedback = null
        return
      }
      const validVin = IdentifierUtils.validVinFormat(newVal)
      if (validVin) {
        this.vin.value = validVin
        this.vin.state = true
        this.vin.invalidFeedback = null
      } else {
        this.vin.state = false
        this.vin.invalidFeedback = this.$i18n.t('annonce.vin.invalidFeedBack')
      }
    },

    updateFeedbackBicycode() {
      var newVal = this.bicycode.value
      if(newVal === null || newVal === "" || newVal.trim() === "") {
        this.bicycode.value = null
        this.bicycode.state = null
        this.bicycode.invalidFeedback = null
        return
      }
      const validBicycode = IdentifierUtils.validBicycodeFormat(newVal)
      if (validBicycode) {
        this.bicycode.value = validBicycode
        this.bicycode.state = true
        this.bicycode.invalidFeedback = null
      } else {
        this.bicycode.state = false
        this.bicycode.invalidFeedback = this.$i18n.t('annonce.bicycode.invalidFeedBack')
      }
    },

    removeInvalidFeedback (field) {
      this.annonce[field]['state'] = null
    },
  },
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    height: 100%;
    overflow: auto;
  }
  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.choice-id-vehicule{
  display: flex;
  justify-content: center;
  color: var(--main-grey-medium);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.custom-append-locate{
  background-color: var(--main-black-light) !important;
  border: 1px solid var(--main-grey-dark) !important;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-append-locate-disabled {
  background-color: var(--main-black-medium) !important;
  border: 1px solid var(--main-grey-dark) !important;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-disabled {
  color: var(--main-black-darker);
}

.radio-proprio{
  color: var(--main-grey-light);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep4.vue